import { ArrowBack } from "@mui/icons-material";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export function NewDistribution() {
  const navigate = useNavigate();

  const handleGoBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <Stack spacing={2}>
      <Stack spacing={2} direction="row">
        <Button
          onClick={handleGoBack}
          size="small"
          color="primary"
          startIcon={<ArrowBack />}
        >
          Voltar
        </Button>
        <Typography variant="h6">Nova distribuição</Typography>
      </Stack>
    </Stack>
  );
}
